(function (window, document) {
  'use strict';

  var DISPLAY_DURATION = 6;
  var FADE_DURATION = 0.5;

  function FrontPageCoverCarousel(options) {
    this.rootSelector = options.rootSelector;
    this.panelSelector = options.panelSelector;
    this.root = document.querySelector(this.rootSelector);
    this.panels = this.root ? this.root.querySelectorAll(this.panelSelector) : [];
    this.timeline = null;
  }

  FrontPageCoverCarousel.prototype.init = function () {
    if (!this.canAnimate() || !this.root || !this.panels.length) {
      return;
    }

    this.setInitialState();

    if (this.panels.length < 2 || this.prefersReducedMotion()) {
      return;
    }

    this.buildTimeline();
  };

  FrontPageCoverCarousel.prototype.canAnimate = function () {
    return typeof window.gsap !== 'undefined';
  };

  FrontPageCoverCarousel.prototype.prefersReducedMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  FrontPageCoverCarousel.prototype.setInitialState = function () {
    window.gsap.set(this.root, {
      autoAlpha: 1,
    });

    window.gsap.set(this.panels, {
      autoAlpha: 0,
      zIndex: 0,
    });

    window.gsap.set(this.panels[0], {
      autoAlpha: 1,
      zIndex: 1,
    });
  };

  FrontPageCoverCarousel.prototype.buildTimeline = function () {
    var currentIndex;
    var nextIndex;

    this.timeline = window.gsap.timeline({
      repeat: -1,
      defaults: {
        duration: FADE_DURATION,
        ease: 'none',
      },
    });

    for (currentIndex = 0; currentIndex < this.panels.length; currentIndex += 1) {
      nextIndex = (currentIndex + 1) % this.panels.length;

      this.timeline.set(this.panels[nextIndex], {
        zIndex: 2,
      });

      this.timeline.set(
        this.panels[currentIndex],
        {
          zIndex: 1,
        },
        '<'
      );

      this.timeline.to(
        this.panels[nextIndex],
        {
          autoAlpha: 1,
        },
        '+=' + DISPLAY_DURATION
      );

      this.timeline.to(
        this.panels[currentIndex],
        {
          autoAlpha: 0,
        },
        '<'
      );

      this.timeline.set(this.panels[currentIndex], {
        zIndex: 0,
      });
    }
  };

  function bootFrontPageCoverCarousel() {
    var carousel = new FrontPageCoverCarousel({
      rootSelector: '.front-page__stack',
      panelSelector: '.front-page__panel',
    });

    carousel.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFrontPageCoverCarousel);
    return;
  }

  bootFrontPageCoverCarousel();
})(window, document);
